export default __webpack_public_path__ + "static/media/img-6.8d6e5eec.png";